import { render, staticRenderFns } from "./ReferenceMsg.vue?vue&type=template&id=3239ffcb&scoped=true&lang=pug&"
import script from "./ReferenceMsg.vue?vue&type=script&lang=js&"
export * from "./ReferenceMsg.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceMsg.vue?vue&type=style&index=0&id=3239ffcb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3239ffcb",
  null
  
)

export default component.exports